"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketAccelerateConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketAccelerateConfigurationOutput.js.map